import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import React, { useRef } from "react";

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure?",
  body,
  confirmText = "Delete",
  cancelText = "Cancel",
  isDestructive = true,
  isLoading = false,
}) {
  const cancelRef = useRef();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay bg="blackAlpha.400" />
      <AlertDialogContent borderRadius="lg" mx={4}>
        <AlertDialogHeader fontSize="lg" fontWeight="semibold">
          {title}
        </AlertDialogHeader>
        <AlertDialogBody fontSize="sm" color="gray.600">
          {body}
        </AlertDialogBody>
        <AlertDialogFooter gap={3}>
          <Button ref={cancelRef} variant="ghost" onClick={onClose}>
            {cancelText}
          </Button>
          <Button
            colorScheme={isDestructive ? "red" : "brand"}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
